/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react'
import noUiSlider from 'nouislider'
import { useLayout, usePageData } from '../../core'
import { KTSVG } from '../../../helpers'
import { DefaultTitle } from './page-title/DefaultTitle'
import { ThemeModeSwitcher } from '../../../partials'

const HeaderToolbar = () => {
  const { classes } = useLayout()
  const [status, setStatus] = useState<string>('')
  const { pageTitle } = usePageData()

  useEffect(() => {
    const rangeSlider = document.querySelector('#kt_toolbar_slider')
    const rangeSliderValueElement = document.querySelector('#kt_toolbar_slider_value')

    if (!rangeSlider || !rangeSliderValueElement) {
      return
    }

    // @ts-ignore
    noUiSlider.create(rangeSlider, {
      start: [5],
      connect: [true, false],
      step: 1,
      format: {
        to: function (value) {
          const val = +value
          return Math.round(val).toString()
        },
        from: function (value) {
          return value
        },
      },
      range: {
        min: [1],
        max: [10],
      },
    })

    // @ts-ignore
    rangeSlider.noUiSlider.on('update', function (values, handle) {
      rangeSliderValueElement.innerHTML = values[handle]
    })

    const handle = rangeSlider.querySelector('.noUi-handle')
    if (handle) {
      handle.setAttribute('tabindex', '0')
    }

    // @ts-ignore
    handle.addEventListener('click', function () {
      // @ts-ignore
      this.focus()
    })

    // @ts-ignore
    handle.addEventListener('keydown', function (event) {
      // @ts-ignore
      const value = Number(rangeSlider.noUiSlider.get())
      // @ts-ignore
      switch (event.which) {
        case 37:
          // @ts-ignore
          rangeSlider.noUiSlider.set(value - 1)
          break
        case 39:
          // @ts-ignore
          rangeSlider.noUiSlider.set(value + 1)
          break
      }
    })
    return () => {
      // @ts-ignore
      rangeSlider.noUiSlider.destroy()
    }
  }, [])

  return (
    <>
      <div className='toolbar d-flex align-items-stretch justify-content-between'>

        <div
          className={`${classes.headerContainer.join(
            ' '
          )} py-6 py-lg-0 d-flex flex-column flex-lg-row align-items-lg-stretch justify-content-lg-between`}
        >
          <DefaultTitle />

          {/* {((window.location.pathname !== "/dashboard") && (window.location.pathname !== "/data") && (window.location.pathname !== "/mr_details")) &&
            <div className='d-flex align-items-stretch overflow-auto pt-3 pt-lg-0'>

              <div className='d-flex align-items-center'>
                <div className='d-flex align-items-center'>
                  <input className='search-input'
                    placeholder=' 🔍 search '
                    style={{ outline: 'none', width: '200px', borderRadius: '8px', border: 'solid #F2F2F2 1px', fontSize: '16px', padding: '8px' }} />
                </div>
                <div className='bullet bg-secondary h-35px w-1px mx-5'></div>
              </div>
              {window.location.pathname === '/mr_list' && <div className='d-flex align-items-center'>
                <select
                  className='form-select form-select-sm form-select-solid w-100px w-xxl-125px p-3'
                  data-control='select2'
                  data-placeholder='Filter by zone'
                  data-hide-search='true'
                  defaultValue={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value=''>Filter by zone</option>
                  <option value='1'>Latest</option>
                  <option value='2'>In Progress</option>
                  <option value='3'>Done</option>
                </select>
              </div>}

              {window.location.pathname === '/zone_management' && <div className='d-flex align-items-center'>
                <button className='add-zone-btn' style={{ borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px' }} >+ Add Zone</button>
              </div>}
            </div>} */}

        </div>
      </div>
    </>
  )
}

export { HeaderToolbar }
